import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    root: {
      '& .MuiTypography-h6': {
        fontSize: 14,
      },

      '& .MuiDialogContentText-root': {
        fontSize: 12,
      },

      '& .MuiButton-root': {
        fontSize: 14,
        fontWeight: 300,
        color: palette.blue,
      },

      '& strong, & b': {
        fontWeight: 600,
      },
    },

    small: {
      textAlign: 'center',

      '& .MuiDialog-paperWidthSm': {
        maxWidth: 280,
      },

      '& .MuiDialogTitle-root': {
        paddingBottom: 8,
      },

      '& .MuiTypography-h6': {
        fontSize: 14,
      },

      '& .MuiDialogContentText-root': {
        fontSize: 14,
      },

      '& .MuiTypography-root': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    },

    icon: {
      display: 'flex',
      justifyContent: 'center',
      paddingTop: 16,

      '& svg': {
        width: 30,
        height: 30,
      },
    },
    alignActionButtons: {
      display: 'flex',
      justifyContent: 'center',
    },
  });
